import { SessionContext } from '@contexts/session-context';
import React, { useContext, useEffect } from 'react';

const Beamer = () => {
  const { session } = useContext(SessionContext);
  const { tenant, user } = session ?? {};
  const { subscription } = tenant ?? {};
  const { plan, status } = subscription ?? {};

  useEffect(() => {
    const url = window.location.href;
    const allowedUrls = /^https:\/\/[a-zA-Z0-9-]+\.testsigma\.com/;

    if (allowedUrls.test(url)) {
      const beamerScript = document.createElement('script');
      beamerScript.innerHTML = `
      window.beamer_config = {
        product_id: "MDDsHoHE28303",
        selector: "beamer-trigger",
        user_id:${user?.id},
        user_email: "${user?.email}",
        user_firstname: "${user?.firstName}",
        user_lastname: "${user?.lastName}",
        tenant_id: ${tenant?.id},
        domain_name: "${window.location.hostname}",
        jarvis_login: "${user?.authType == 'ADMIN_SSO' ? 'Yes' : 'No'}",
        plan_type: "${plan}",
        type: "${status}",
        ts_userid: ${user?.id},
      }`;
      document.body.appendChild(beamerScript);
      const script = document.createElement('script');
      script.src = 'https://app.getbeamer.com/js/beamer-embed.js';
      script.defer = true;
      document.body.appendChild(script);
    }
  }, []);

  return <></>;
};

export default Beamer;
